<div class="header">
  <div class="page_header">
    <div class="left">
      <app-page-close-button (closePage)="goBack()"></app-page-close-button>
      <div class="title">Tally</div>
    </div>
    <div class="right">
      @if (readOnlyMode) {
        <button class="secondary_button" (click)="goBack()">Go Back</button>
      }
      @if (!readOnlyMode) {
        <button class="secondary_button" (click)="goBack()">Cancel</button>
        <button class="primary_button" (click)="submitForm()">@if (editingEnabled) {
          Update
        } @else if (addNewMode) {
          Save
        }</button>
      }
    </div>
  </div>
</div>
<div class="full_page_container">
  @if (addNewMode) {
    <div class="search_bar_tally">
      <label class="required_field_label">JO No/IGM item No</label>
      <app-autocomplete-dropdown
        #jobOrderInventorySearch
        id="JobOrderInventory"
        name="JobOrderInventory"
        [placeholder]="'Enter Job Order No/IGM Item No'"
        [apiUrl]="'v1/job-order-inventories/list?onlyOpenJobOrders=true'"
        [selectFields]="['id',
        'jobOrderNo',
        'jobOrderNo.id as jobOrderId',
        'jobOrderNo.expiryDate as dueDate',
        'jobOrderNo.createdDate as issueDate',
        'inventoryId',
        'inventoryNo',
        'jobOrderNo.jobOrderType as jobOrderType',
        'jobOrderNo.additionalDetails as additionalDetails'
        ]"
        [filterByKeys]="['jobOrderNo','inventoryNo']"
        [limit]="10"
        [orderBy]="{ jobOrderNo: 'asc' }"
        [filterByKey]="'jobOrderNo'"
        [bindLabel]="'jobOrderNo'"
        [bindValue]="'id'"
        [displayColumns]="[
                        { key: 'jobOrderNo', header: 'Job Order Number' },
                        { key: 'inventoryNo', header: 'Inventory Number' },
                        { key: 'jobOrderType', header: 'Job Order Type' }
                    ]"
        (suggestionSelected)="jobOrderSelected($event)"
      ></app-autocomplete-dropdown>
    </div>
  }
  <div class="content">
    @if (!tallyType){
      <app-no-data [msg]="'Enter the Item No or Job order number above to Perform Tally.'"></app-no-data>
    }
    <ng-template #tallyRenderer></ng-template>
  </div>
</div>
